module.exports = __webpack_public_path__ + "static/media/moon.9fae7645.svg";